import React, {Component} from 'react'
import {connect} from 'react-redux'
import IgniteDataTable from '../common/datatable'
import {history} from '../../store';
import {deleteSavedOrder, completeOrder} from '../../actions/orders'
import {getMyProfile} from '../../actions/user';
import {dateFormat} from '../../utils/commonFunctions';

class OrdersList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  render() {
    const columns = [
      {prop: 'order-date', title: 'Order Saved Date', width: '170', format(data, row) {return dateFormat(data)}},
      {prop: 'your-reference', title: 'Reference', width: '150'},
      {prop: 'order-value', title: 'Order Value', width: '150'},
    ];

    const actions = [
      {
        label: 'Complete order',
        permissions: {
          action: 'order',
          subjectClass: 'stock'
        },
        callback: (row) => {
          this.props.dispatch(completeOrder(row.id))
              .then((response) => {
                this.props.dispatch(getMyProfile('CURRENT_USER_PROFILE'));
                history.push('/order/new');
              });
        }
      },
      {
        label: 'Delete',
        color: 'grey',
        callback: (row) => {
          this.props.dispatch(deleteSavedOrder(row.id));
        },
      },
    ];

    return (
      <IgniteDataTable data={this.props.orders}
                       dataSize={this.props.pagination.number * this.props.pagination.size}
                       columns={columns}
                       actions={actions}
                       pagination={{
                         onPageChange: this.props.onPageChange,
                         page: this.props.currentPage
                       }}
                       inlineActions={false}
                       actionWidth="220"
                       remote />
    )
  }
}

export default connect()(OrdersList)


// WEBPACK FOOTER //
// ./src/components/my-orders/saved-orders-list.jsx